import { render } from "./CCOReferralsScheduling.vue?vue&type=template&id=7446f014&scoped=true&lang=pug"
import script from "./CCOReferralsScheduling.vue?vue&type=script&lang=js"
export * from "./CCOReferralsScheduling.vue?vue&type=script&lang=js"

import "./CCOReferralsScheduling.vue?vue&type=style&index=0&id=7446f014&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7446f014"]])

export default __exports__